import _ from "lodash";

/**
 * Takes an object and creates a deep clone of it.
 * @param {any} obj The object to clone.
 * @returns {any} The cloned object.
 */
export function cloneDeep(obj: any): any {
  return _.cloneDeep(obj);
}
